import { useMemo } from "react";
import { useTranslation } from "@crehana/i18n";
import { Row } from "@crehana/ui";
import { excludeFooterLinksByLabel } from "../utils/excludeFooterLinksByLabel";
import AppsColumn from "../components/AppsColumn";
import LinksColumn from "../components/LinksColumn";
import { COMMUNITY_LINKS, COMPANY_LINKS, HELP_LINKS } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TopSection = function TopSection(_ref) {
  var isDark = _ref.isDark,
    _ref$shouldHideWeAreH = _ref.shouldHideWeAreHiringLink,
    shouldHideWeAreHiringLink = _ref$shouldHideWeAreH === void 0 ? false : _ref$shouldHideWeAreH;
  var _useTranslation = useTranslation(),
    countryCode = _useTranslation.countryCode;
  var COMPANY_LINKS_FILTERED = useMemo(function () {
    return excludeFooterLinksByLabel(COMPANY_LINKS, [shouldHideWeAreHiringLink ? 'COMPANY_HIRING' : undefined]);
  }, [shouldHideWeAreHiringLink]);
  var COMMUNITY_LINKS_FILTERED = useMemo(function () {
    return excludeFooterLinksByLabel(COMMUNITY_LINKS(countryCode), []);
  }, [countryCode]);
  return /*#__PURE__*/_jsxs(Row, {
    className: "pt-32 mb-32 sm:pt-48 lg:pt-64 md:mb-16 lg:mb-64",
    children: [COMPANY_LINKS_FILTERED.length > 0 && /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "COMPANY_TITLE",
      links: COMPANY_LINKS_FILTERED
    }), /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "HELP_TITLE",
      links: HELP_LINKS(countryCode)
    }), COMMUNITY_LINKS_FILTERED.length > 0 && /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "COMMUNITY_TITLE",
      links: COMMUNITY_LINKS_FILTERED
    }), /*#__PURE__*/_jsx(AppsColumn, {
      isDark: isDark,
      className: "hidden md:block"
    })]
  });
};
export default TopSection;